import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';

const Group = styled.div`
  width: 100%;
  max-width: 662px;
  margin: 0 auto;
`;
const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 0 12px;
  width: 100%;
  max-width: 662px;
  margin: 0 auto;
  align-items: center;
`;

const PersonalText = styled.div`
  ${Typography.heading_lg}
  color: var(--text-primary);
`;

const Box = styled.div`
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
`;

const Content = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const Label = styled.label`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
`;
const InputValue = styled.input`
  ${Typography.body_lg}
  color: var(--text-secondary);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-6);
  padding: 7px 12px;
  outline: none;
  :focus {
    border: 0.5px solid var(--brand-primary);
    z-index: 999;
  }
`;

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SocialIcon = styled.div`
  display: flex;
  gap: 10px;
  ${mobile_xl(css`
    gap: 12px;
  `)}
`;
const Icon = styled.div`
  cursor: pointer;
  width: 24px;
  height: 24px;
  .social-icon {
    fill: var(--text-secondary);
    path {
      fill: var(--text-white);
    }
  }
  .facebook-icon {
    :hover {
      fill: var(--brand-primary);
    }
  }
  .email-icon {
    :hover {
      fill: var(--brand-primary);
    }
  }
  .twitter-icon {
    :hover {
      fill: var(--brand-primary);
    }
  }
`;
const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
  ${mobile_xl(css`
    margin-block: 8px 80px;
    gap: 12px;
  `)}
`;
const Total = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 16px;
  ${mobile_xl(css`
    width: 100%;
    grid-template-columns: repeat(1, 1fr);
    gap: 12px;
  `)}
`;

const ButtonWrapper = styled.div`
  display: flex;
`;

export {
  Group,
  Header,
  PersonalText,
  Box,
  Content,
  Form,
  Label,
  InputValue,
  Buttons,
  SocialIcon,
  Icon,
  Bottom,
  Total,
  ButtonWrapper
};
